import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import './EditVoucher.css';
import FormPageHeader from "../utilities/FormPageHeader";
import CustomDatePicker from "../utilities/CustomDatePicker";
import Select from "react-select";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import moment from "moment/moment";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import AgGridTable from "../utilities/AgGridTable";
import TextSearchableCellEditor from "../voucher/TextSearchableCellEditor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import customStyles from "app/shared-components/SelectCustomStyle";
import { checkNumber, checkSpecialChar } from "../utilities/FormValidation";
import { styled } from "@mui/styles";
import { useTheme } from "@mui/system";
import ViewVoucher from "./ViewVoucher";
import VoucherType from "./voucherType/VoucherType";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
    }),
    /**
     * This is necessary to enable the selection of content. In the DOM, the stacking order is determined
     * by the order of appearance. Following this rule, elements appearing later in the markup will overlay
     * those that appear earlier. Since the Drawer comes after the Main content, this adjustment ensures
     * proper interaction with the underlying content.
     */
    position: "relative",
  })
);

const EditVoucher = () => {
  const gridRef = useRef();
  const theme = useTheme();
  const navigate = useNavigate();
  const [showView, setShowView] = useState(false);
  const allowedFormatToView = ['pdf', 'svg', 'jpg', 'jpeg', 'svg', 'png'];
  const [totalAllocated, setTotalAllocated] = useState(0);
  const [voucherData, setVoucherData] = useState({
    refDocNo: "",
    currency: "EUR",
    voucherType: { id: "" },
    voucherReference: "",
    docDate: null,
    docDescription: "",
    euroRate: Number(1).toFixed(4),
    invoiceNo: "",
    invoiceDate: null,
    invoiceDocument: "",
    companyCode: "1",
    // bank :"",
    // amount:"",
    ledgerList: [],
    customer: '',
    amountReceived: 0,
    bankCharges: 0,
    backChargeToClient: false,
    bank: '',
    NFZEbank: '',
    receiptType: 'LC'
  });
  const [oldEditData, setOldEditData] = useState();
  const [oldEditRowData, setOldEditRowData] = useState();
  const [error, setError] = useState();
  const [docRef, setDocRef] = useState();
  const { state } = useLocation();
  const [formOpen, setFormOpen] = useState(false);
  const [euroRateOpen, setEuroRateOpen] = useState(false);
  const [attachmentOpen, setAttachmentOpen] = useState(false);
  const [futureEuroRate, setFutureEuroRate] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [validError, setValidError] = useState({});
  const params = useParams();
  const [checksubmit, setCheckSubmit] = useState("");
  const [checkAttachment, setCheckAttachment] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [saveDisable, setSaveDisable] = useState(true);
  const [removedTransaction, setRemovedTransaction] = useState([]);
  const [totalDebits, setTotalDebits] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const [allocationRowDataToBeAllocated, setAllocationRowDataToBeAllocated] = useState(0);
  const [allocationRowDataAllocated, setAllocationRowDataAllocated] = useState(0);
  const [AEDEuroRate, setAEDEuroRate] = useState();
  const [documentFile, setDocumentFile] = useState([]);
  const [drawer, setDrawer] = useState(false);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([
    { label: 'Cash', value: 'CASH' },
    { label: 'TT- Telegrapgic Transfer', value: 'TT' },
    { label: 'LC- Letter of Credit', value: 'LC' },
    { label: 'Others', value: 'OTHERS' },
  ]);
  const [bankOptions, setBankOptions] = useState([]);
  const [NFZEbankOptions, setNFZEBankOptions] = useState([]);
  const [receiptTypeOptions, setReceiptTypeOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [subLedgrOptions, setSubLedgrOptions] = useState([]);
  const [oldRefData, setOldRefData] = useState([]);
  const [allocationRowData, setAllocationRowData] = useState([]);
  const [allocationRowDataCashReceipt, setAllocationRowDataCashReceipt] = useState([]);
  const [allocationColumnDefs, setAllocationColumnDefs] = useState([
    { field: "abNumber", headerName: "AB No" },
    { field: "dueDate", eaderName: "Due Date" },
    { field: "invoiceAmount", headerName: "Amount" },
    { field: "paid", headerName: "Paid" },
    { field: "balance", headerName: "Balance" },
    { field: "allocated", headerName: "Allocated" },
  ]);
  const [allocationType, setAllocationType] = useState('BANK_REF_NO');
  const allocationOptions = [{ label: "Bank Ref", value: "BANK_REF_NO" },
  { label: "Other Payables", value: "OTHER_PAYABLES" }];
  const renderCurrency = (props) => {
    const options = {
      style: "decimal", // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    const decimalValue = props?.value
      ? Number(props?.value).toLocaleString("en-US", options)
      : 0.00;
    return (
      <span style={{ display: "flex" }}>
        <p>{props.value && decimalValue}</p>
      </span>
    );
  };
  const [allocationColumnDefsCashReceipt, setAllocationColumnDefsCashReceipt] = useState([
    { field: "id", headerName: "AB No", editable: false },
    { field: "expiryDate", eaderName: "Due Date", editable: false },
    { field: "amount", headerName: "Amount", editable: false },
    { field: "paid", headerName: "Paid", editable: false },
    { field: "balance", headerName: "Balance", editable: false },
    {
      field: "allocated", headerName: "Allocated", cellRenderer: renderCurrency,
      type: "editableColumn",
      editable: true,
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null
          ? Number(params.value).toFixed(2)
          : 0.00,
    },
  ]);

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "account",
      headerName: "Account",
      cellEditor: TextSearchableCellEditor,
      minWidth: (state?.vouchertype === '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b') ? "200" : "430",
    },
    {
      field: "debit",
      headerName: "Debit",
      cellRenderer: renderCurrency,
      type: "editableColumn",
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null
          ? Number(params.value).toFixed(2)
          : 0.00,
    },
    {
      field: "credit",
      headerName: "Credit",
      cellRenderer: renderCurrency,
      type: "editableColumn",
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null
          ? Number(params.value).toFixed(2)
          : 0.00,
    },
    { field: "currency", headerName: "Currency", editable: false },
    {
      field: "exchangeRate", headerName: "Exchange Rate", editable: false,
      valueFormatter: (params) => (params.value !== undefined && params.value !== null) ? Number(params.value).toFixed(4) : 0.0000,
    },
    {
      field: "hcurrDR",
      headerName: "H. Debit",
      editable: false,
      cellRenderer: renderCurrency,
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null
          ? Number(params.value).toFixed(2)
          : 0.00,
    },
    {
      field: "hcurrCR",
      headerName: "H. Credit",
      editable: false,
      cellRenderer: renderCurrency,
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null
          ? Number(params.value).toFixed(2)
          : 0.00,
    },
    { field: "lineDescription", headerName: "Line Description" },
    { field: "accountNumber", hide: true },
    { field: "name", hide: true },
    { field: "subLegId", hide: true },
    { field: "headId", hide: true },
    { field: "headName", hide: true },
    { field: "groupId", hide: true },
    { field: "groupName", hide: true },
    { field: "generalLedgerId", hide: true },
    { field: "generalLedgerName", hide: true },
    { field: "ledgerId", hide: true },
    { field: "ledgerName", hide: true },
  ]);

  const modalName = 'View Document';

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  }

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        {
          statusPanel: 'agAggregationComponent',
          statusPanelParams: {
            // possible values are: 'count', 'sum', 'min', 'max', 'avg'
            aggFuncs: ['min', 'max', 'avg', 'sum']
          }
        }
      ]
    };
  }, []);
  const voucherUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucher}`;
  const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;
  const reconciliationUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.reconciliation}`;

  const handleDateChange = (value) => {
    if (voucherData.currency === "EUR") {
      setVoucherData({
        ...voucherData,
        docDate: moment(value).format("YYYY-MM-DD"),
        euroRate: 1.0000,
      });
    } else if (voucherData.currency === "AED") {
      const currentDate = new Date();
      const selectedDate = new Date(moment(value).format("YYYY-MM-DD"));
      if (selectedDate >= currentDate) {
        setVoucherData({
          ...voucherData,
          docDate: moment(value).format("YYYY-MM-DD"),
          euroRate: 0.0000,
        });
        setEuroRateOpen(true);
      } else {
        getEuroRateValue(moment(value).format("YYYY-MM-DD"), {
          ...voucherData,
          docDate: moment(value).format("YYYY-MM-DD"),
        });
      }
    } else {
      setVoucherData({
        ...voucherData,
        docDate: moment(value).format("YYYY-MM-DD"),
        euroRate: 0.0000,
      });
    }
  };

  const handleChangeReceiptType = (event) => {
    setVoucherData({ ...voucherData, receiptType: event.value });
  }

  const handleChangeCurrency = (event) => {
    if (event.value === "EUR") {
      setVoucherData({ ...voucherData, currency: event.value, euroRate: 1.0000 });
    } else if (event.value === "AED") {
      setVoucherData({ ...voucherData, currency: event.value });
      const currentDate = new Date();
      const selectedDate = new Date(voucherData.docDate);
      if (selectedDate >= currentDate) {
        setEuroRateOpen(true);
      } else {
        getEuroRateValue(voucherData.docDate, {
          ...voucherData,
          currency: event.value,
        });
      }
    } else {
      setVoucherData({ ...voucherData, currency: event.value, euroRate: 0.0000 });
    }
  };

  const loadAllocationData = async () => {
    let docDescription = "";
    const loadData = await OAuthService.getList(
      reconciliationUrl + `/getBankAllocation?docDescription=${docDescription}`
    );
    setAllocationRowData(loadData.data);
    let allocatedTotal = 0;
    if (loadData?.data && loadData?.data.length > 0) {
      loadData?.data.map((data) => {
        if (data?.allocated) {
          allocatedTotal = allocatedTotal + Number(data?.allocated)
        }
        return data;
      })
      setAllocationRowDataAllocated(allocatedTotal);
      setAllocationRowDataToBeAllocated(voucherData?.amount)
    }
  };

  useEffect(() => {
    loadAllocationData();
    console.log(":: voucher type", state?.vouchertype)
  }, []);

  const handleCompanyChange = (event) => {
    setVoucherData({ ...voucherData, companyCode: event.value });
  };

  const handleCustomerChange = (event) => {
    console.log(":: event", event);
    setVoucherData({ ...voucherData, customer: event.value });
  };

  const handleinvoiceNoChange = (event) => {
    setVoucherData({ ...voucherData, invoiceNo: event.target.value });
  };
  const handlePaymentTypeChange = (event) => {
    setVoucherData({ ...voucherData, paymentType: event.value });
  };
  const handleVendorCodeChange = (event) => {
    setVoucherData({ ...voucherData, vendorCode: event.target.value });
  };
  const handleVendorNameChange = (event) => {
    setVoucherData({ ...voucherData, vendorName: event.target.value });
  };
  const handleBankChange = (event) => {
    setVoucherData({ ...voucherData, bank: event.value });
  };
  const handleBankNFZChange = (event) => {
    setVoucherData({ ...voucherData, NFZEbank: event.value });
  };
  const handleChqNoChange = (event) => {
    setVoucherData({ ...voucherData, chequeNo: event.target.value });
  };
  const handleAmountChange = (event) => {
    setVoucherData({ ...voucherData, amount: event.target.value });
  };
  const handleEuroChange = (event) => {
    setVoucherData({ ...voucherData, euroRate: event.target.value });
  };
  const handleEuroRateSave = () => {
    setVoucherData({
      ...voucherData,
      euroRate: Number(futureEuroRate).toFixed(4),
    });
    handleEuroRateClose();
  };

  const handleinvoiceDateChange = (value) => {
    setVoucherData({
      ...voucherData,
      invoiceDate: moment(value).format("YYYY-MM-DD"),
    });
  };

  const handleDocDescriptionChange = (event) => {
    setVoucherData({ ...voucherData, docDescription: event.target.value });
  };

  const handleAmountReceivedChange = (event) => {
    setVoucherData({ ...voucherData, amountReceived: event.target.value });
  }

  const handleBankChargesChange = (event) => {
    setVoucherData({ ...voucherData, bankCharges: event.target.value });
  }

  const handleBankChargesToClientChange = (event) => {
    setVoucherData({ ...voucherData, backChargeToClient: event.target.checked });
  }

  const handleSubmitAttachment = () => {
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setShowView(false);
  };
  const handleEuroRateClose = () => {
    setEuroRateOpen(false);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleSubmit = async () => {
    setCheckSubmit(true);
    debugger;
    const rows = JSON.parse(JSON.stringify(rowData));
    let updatedData = rows.map((data) => {
      data.debit = data?.debit ? Number(data?.debit) : 0.00;
      data.credit = data?.credit ? Number(data?.credit) : 0.00;
      data.exchangeRate = data?.exchangeRate ? Number(data?.exchangeRate).toFixed(4) : 0.0000;
      data.hcurrCR = data?.hcurrCR ? Number(data?.hcurrCR) : 0.00;
      data.hcurrDR = data?.hcurrDR ? Number(data?.hcurrDR) : 0.00;
      return data;
    });
    const cloneVoucherData = { ...voucherData };
    let voucherObj = { ...voucherData, ledgerList: updatedData };
    if (state?.vouchertype === "650d3389c11f3c7fa34e084b") {
      let updatedAllocationData = allocationRowDataCashReceipt.map((allocation) => ({
        ...allocation,
        allocated: parseInt(allocation.allocated)
      }));
      const payload = {
        "customerNum": voucherData.customer,
        "customerName": "",
        paymentType: voucherData.receiptType,
        "amountReceived": parseInt(voucherData.amountReceived),
        "bankCharges": voucherData.bankCharges,
        "allocationType": allocationType,
        "amountToBeAllocated": totalCredits,
        "allocated": 100,
        "balance": 0,
        "srNo": 0,
        bank: voucherData.NFZEbank,
        listAllocation: updatedAllocationData
      };
      delete voucherData.NFZEbank;
      delete voucherObj.NFZEbank;
      delete voucherData.bank;
      delete voucherObj.bank;
      delete voucherData.customer;
      delete voucherObj.customer;
      delete voucherData.receiptType;
      delete voucherObj.receiptType;
      // delete voucherData.backChargeToClient;
      // delete voucherObj.backChargeToClient;
      voucherObj = { ...voucherObj, ...payload };
    } else {
      delete voucherData.NFZEbank;
      delete voucherData.bank;
      delete voucherData.backChargeToClient;
      delete voucherData.bankCharges;
      delete voucherData.customer;
      delete voucherData.receiptType
    }
    try {
      if (documentFile.length !== 0) {
        const formData = new FormData();
        formData.append("file", documentFile);

        const uploadData = await OAuthService.uploadFile(uploadUrl, formData);
        if (uploadData.data) {
          if (uploadData.data.error) {
            setError(uploadData.data.error);
          } else {
            voucherObj = {
              ...voucherObj,
              invoiceDocument: uploadData.data.fileName,
            };
          }
        }
      }
      if (params?.id) {
        let editData = updatedData.map((data) => {
          data.voucherId = data.voucherId ? data.voucherId : "";
          data.account = {
            subLegId: data.subLegerId,
            headId: data.headId,
            headName: data.headName,
            groupId: data.groupId,
            groupName: data.groupName,
            generalLedgerId: data.generalLedgerId,
            generalLedgerName: data.generalLedgerName,
            ledgerId: data.ledgerId,
            ledgerName: data.ledgerName,
          };
          if (!data.lineDescription) {
            data.lineDescription = voucherObj.docDescription;
          }
          data.accountName = data.name || data.accountName;
          data.homeCurrencyCredit = data.hcurrCR;
          data.homeCurrencyDebit = data.hcurrDR;
          delete data.subLegerId;
          delete data.headId;
          delete data.headName;
          delete data.groupId;
          delete data.groupName;
          delete data.generalLedgerId;
          delete data.generalLedgerName;
          delete data.ledgerId;
          delete data.ledgerName;
          delete data.subLegId;
          delete data.hcurrCR;
          delete data.subLegId;
          delete data.name;
          // delete data.postDate;
          delete data.hcurrDR;
          return data;
        });
        voucherObj = {
          ...voucherObj,
          voucherType: editData[0].voucherType,
          voucherTransactionList: editData,
        };
        delete voucherObj.ledgerList;

        if (removedTransaction.length > 0) {
          await OAuthService.addData(
            voucherUrl + "/deleteVoucherTransaction",
            removedTransaction
          );
        }
        delete voucherObj.voucherNo;
        delete voucherObj.refDocNo;
        delete voucherObj.docRef;
        delete voucherObj.postDate;
        delete voucherObj.postDate;
        const getData = await OAuthService.addData(
          voucherUrl + "/updateVoucher",
          voucherObj
        );
        // if (getData?.data) {
        setSuccessMsg("Voucher updated successfully");
        setSnackState(true);
        setTimeout(() => {
          navigate("/voucher");
        }, 800);
        // }
      } else {
        if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
          if (voucherObj.invoiceDocument) {
            if (documentFile.length !== 0) {
              let newData = voucherObj.ledgerList.map((data) => {
                delete data.account;
                delete data.subLegId;
                delete data.postDate;
                if (!data.lineDescription) {
                  data.lineDescription = voucherObj.docDescription;
                }
                return data;
              });
              if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
                if (JSON.stringify(newData) !== JSON.stringify(oldRefData)) {
                  voucherObj = {
                    ...voucherObj,
                    voucherReference: "NO_REFERENCE",
                  };
                }
              }
              const newpayload = { ...voucherData };

              voucherObj = { ...voucherData, ledgerList: newData };
              const getData = await OAuthService.addData(
                voucherUrl + "/createVoucher",
                voucherObj
              );
              // if (getData?.data) {
              setSuccessMsg("Voucher created successfully");
              setSnackState(true);
              setTimeout(() => {
                navigate("/voucher");
              }, 800);
              // }
            } else {
              if (checkAttachment) {
                if (checkAttachment === "yes") {
                  let newData = voucherObj.ledgerList.map((data) => {
                    delete data.account;
                    delete data.subLegId;
                    delete data.postDate;
                    delete data.subLegId;
                    delete data.postDate;
                    if (!data.lineDescription) {
                      data.lineDescription = voucherObj.docDescription;
                    }
                    return data;
                  });
                  if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
                    if (
                      JSON.stringify(newData) !== JSON.stringify(oldRefData)
                    ) {
                      voucherObj = {
                        ...voucherObj,
                        voucherReference: "NO_REFERENCE",
                      };
                    }
                  }
                  voucherObj = { ...voucherData, ledgerList: newData };
                  delete voucherObj.voucherNo;
                  delete voucherObj.voucherNo;
                  const getData = await OAuthService.addData(
                    voucherUrl + "/createVoucher",
                    voucherObj
                  );
                  // if (getData?.data) {
                  setSuccessMsg("Voucher created successfully");
                  setSnackState(true);
                  setAttachmentOpen(false);
                  setTimeout(() => {
                    navigate("/voucher");
                  }, 800);
                } else if (checkAttachment === "no") {
                  let newData = voucherObj.ledgerList.map((data) => {
                    delete data.account;
                    delete data.subLegId;
                    delete data.postDate;
                    if (!data.lineDescription) {
                      data.lineDescription = voucherObj.docDescription;
                    }
                    return data;
                  });
                  if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
                    if (
                      JSON.stringify(newData) !== JSON.stringify(oldRefData)
                    ) {
                      voucherObj = {
                        ...voucherObj,
                        voucherReference: "NO_REFERENCE",
                      };
                    }
                  }
                  voucherObj = { ...voucherData, ledgerList: newData };
                  delete voucherObj.voucherNo;
                  const getData = await OAuthService.addData(
                    voucherUrl + "/createVoucher",
                    voucherObj
                  );
                  // if (getData?.data) {
                  setSuccessMsg("Voucher created successfully");
                  setSnackState(true);
                  setAttachmentOpen(false);
                  setTimeout(() => {
                    navigate("/voucher");
                  }, 800);
                }
              } else {
                setAttachmentOpen(true);
              }
            }
          } else {
            let newData = voucherObj.ledgerList.map((data) => {
              delete data.account;
              delete data.subLegId;
              delete data.postDate;
              if (!data.lineDescription) {
                data.lineDescription = voucherObj.docDescription;
              }
              return data;
            });
            if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
              if (JSON.stringify(newData) !== JSON.stringify(oldRefData)) {
                voucherObj = {
                  ...voucherObj,
                  voucherReference: "NO_REFERENCE",
                };
              }
            }
            voucherObj = { ...voucherData, ledgerList: newData };
            delete voucherObj.voucherNo;
            const getData = await OAuthService.addData(
              voucherUrl + "/createVoucher",
              voucherObj
            );
            // if (getData?.data) {
            setSuccessMsg("Voucher created successfully");
            setSnackState(true);
            setAttachmentOpen(false);
            setTimeout(() => {
              navigate("/voucher");
            }, 800);
            // }
          }
        } else {
          let newData = voucherObj.ledgerList.map((data) => {
            delete data.account;
            delete data.subLegId;
            delete data.postDate;
            if (!data.lineDescription) {
              data.lineDescription = voucherObj.docDescription;
            }
            return data;
          });
          if (voucherObj.voucherReference === "REVERSE_REFERENCE") {
            if (JSON.stringify(newData) !== JSON.stringify(oldRefData)) {
              voucherObj = { ...voucherObj, voucherReference: "NO_REFERENCE" };
            }
          }
          voucherObj = { ...voucherData, ledgerList: newData, ...voucherObj };
          delete voucherObj.voucherNo;
          const getData = await OAuthService.addData(
            voucherUrl + "/createVoucher",
            voucherObj
          );
          // if (getData?.data) {
          setSuccessMsg("Voucher created successfully");
          setSnackState(true);
          setAttachmentOpen(false);
          setTimeout(() => {
            navigate("/voucher");
          }, 800);
          // }
        }


      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const handleCancel = () => {
    navigate("/voucher");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const getEditData = async () => {
    const id = params.id || params.viewid;
    try {
      const refData = await OAuthService.getList(
        voucherUrl + `/getVoucher/${id}`
      );
      if (refData?.data) {
        const ref = [];
        refData?.data.map((data) => {
          setAllocationType(data.allocationType)
          setVoucherData({
            ...voucherData,
            customer: data?.customerNum,
            amountReceived: data?.amountReceived,
            bankCharges: data?.bankCharges,
            backChargeToClient: data?.backChargeToClient,
            NFZEbank: data?.bankName,
            voucherNo: data?.voucherNo,
            voucherType: data?.voucherType?.id ? { id: data?.voucherType?.id } : {},
            voucherReference: data?.voucherReference,
            docDate: data?.docDate,
            currency: data?.currency,
            docDescription: data?.docDescription,
            euroRate: data?.euroRate ? Number(data?.euroRate).toFixed(4) : 0.0000,
            postDate: data?.postDate,
            docRef: data?.docRef,
            refDocNo: data?.refDocNo,
            invoiceNo: data?.invoiceNo,
            invoiceDate: data?.invoiceDate,
            invoiceDocument: data?.invoiceDocument,
            companyCode: data?.companyCode,
          });

          setAllocationRowDataCashReceipt(data.listAllocation);

          setOldEditData(
            JSON.parse(
              JSON.stringify({
                ...voucherData,
                voucherNo: data?.voucherNo,
                voucherType: { id: data?.voucherType?.id },
                voucherReference: data?.voucherReference,
                docDate: data?.docDate,
                currency: data?.currency,
                docDescription: data?.docDescription,
                euroRate: data?.euroRate ? Number(data?.euroRate).toFixed(4) : 0.0000,
                postDate: data?.postDate,
                docRef: data?.docRef,
                refDocNo: data?.refDocNo,
                invoiceNo: data?.invoiceNo,
                invoiceDate: data?.invoiceDate,
                invoiceDocument: data?.invoiceDocument,
                companyCode: data?.companyCode,
              })
            )
          );
          ref.push({
            ...data,
            hcurrDR: data?.homeCurrencyDebit ? Number(data?.homeCurrencyDebit).toFixed(2) : '0.00',
            exchangeRate: data?.exchangeRate ? Number(data?.exchangeRate).toFixed(4) : 0.0000,
            debit: data?.debit ? Number(data?.debit).toFixed(2) : '0.00',
            credit: data?.credit ? Number(data?.credit).toFixed(2) : '0.00',
            currency: data?.currency,
            hcurrCR: data?.homeCurrencyCredit ? Number(data?.homeCurrencyCredit).toFixed(2) : '0.00',
            account: data?.accountNumber + " " + data?.accountName,
            subLegId: data?.account?.subLegerId,
            headId: data?.account?.headId,
            headName: data?.account?.headName,
            groupId: data?.account?.groupId,
            groupName: data?.account?.groupName,
            generalLedgerId: data?.account?.generalLedgerId,
            generalLedgerName: data?.account?.generalLedgerName,
            ledgerId: data?.account?.ledgerId,
            ledgerName: data?.account?.ledgerName,
          });
          return data;
        });
        setRowData(ref);
        setOldEditRowData(JSON.parse(JSON.stringify(ref)));
      }
    } catch (error) { }
  };
  const getRefData = async (refNo, state) => {
    const refData = await OAuthService.getList(
      voucherUrl + `/getVoucher/${refNo}`
    );
    if (refData?.data) {
      const ref = [];
      refData?.data.map((data) => {
        console.log(data);
        if (state?.refType === "WITH_REFERENCE") {
          setVoucherData({
            ...voucherData,
            voucherNo: data?.voucherNo,
            currency: data?.currency,
            docDescription: data?.docDescription,
            euroRate: data?.euroRate,
            voucherType: { id: state?.vouchertype },
            voucherReference: state?.refType,
            docDate: state?.docDate,
            invoiceNo: data?.invoiceNo,
            refDocNo: refNo,
            invoiceDate: data?.invoiceDate,
            companyCode: data?.companyCode,
          });

          if (data?.currency === 'AED') {
            getEuroRateValue(state?.docDate, {
              ...voucherData,
              voucherNo: data?.voucherNo,
              currency: data?.currency,
              docDescription: data?.docDescription,
              euroRate: data?.euroRate,
              voucherType: { id: state?.vouchertype },
              voucherReference: state?.refType,
              docDate: state?.docDate,
              invoiceNo: data?.invoiceNo,
              refDocNo: refNo,
              invoiceDate: data?.invoiceDate,
              companyCode: data?.companyCode,
            });
          }

          ref.push({
            account: data?.accountNumber + " " + data?.accountName,
            accountNumber: data?.accountNumber,
            name: data?.accountName,
            subLegId: data?.account?.subLegerId,
            headId: data?.account?.headId,
            headName: data?.account?.headName,
            groupId: data?.account?.groupId,
            groupName: data?.account?.groupName,
            debit: data?.debit,
            credit: data?.credit,
            currency: data?.currency,
            exchangeRate: data?.exchangeRate,
            generalLedgerId: data?.account?.generalLedgerId,
            generalLedgerName: data?.account?.generalLedgerName,
            ledgerId: data?.account?.ledgerId,
            ledgerName: data?.account?.ledgerName,
            hcurrDR: data?.homeCurrencyDebit,
            hcurrCR: data?.homeCurrencyCredit,
            lineDescription: data?.lineDescription,
          });
        } else if (state?.refType === "REVERSE_REFERENCE") {
          setVoucherData({
            ...voucherData,
            voucherNo: data?.voucherNo,
            currency: data?.currency,
            docDescription: data?.docDescription,
            euroRate: data?.euroRate ? Number(data?.euroRate).toFixed(4) : 0.0000,
            voucherType: { id: state?.vouchertype },
            voucherReference: state?.refType,
            docDate: state?.docDate,
            invoiceNo: data?.invoiceNo,
            refDocNo: refNo,
            invoiceDate: data?.invoiceDate,
            invoiceDocument: data?.invoiceDocument,
            companyCode: data?.companyCode,
          });
          if (data?.currency === 'AED') {
            getEuroRateValue(state?.docDate, {
              ...voucherData,
              voucherNo: data?.voucherNo,
              currency: data?.currency,
              docDescription: data?.docDescription,
              euroRate: data?.euroRate ? Number(data?.euroRate).toFixed(4) : 0.0000,
              voucherType: { id: state?.vouchertype },
              voucherReference: state?.refType,
              docDate: state?.docDate,
              invoiceNo: data?.invoiceNo,
              refDocNo: refNo,
              invoiceDate: data?.invoiceDate,
              invoiceDocument: data?.invoiceDocument,
              companyCode: data?.companyCode,
            });
          }
          ref.push({
            account: data?.accountNumber + " " + data?.accountName,
            accountNumber: data?.accountNumber,
            name: data?.accountName,
            subLegId: data?.account?.subLegerId,
            headId: data?.account?.headId,
            headName: data?.account?.headName,
            groupId: data?.account?.groupId,
            groupName: data?.account?.groupName,
            debit: data?.credit,
            credit: data?.debit,
            currency: data?.currency,
            exchangeRate: data?.exchangeRate,
            generalLedgerId: data?.account?.generalLedgerId,
            generalLedgerName: data?.account?.generalLedgerName,
            ledgerId: data?.account?.ledgerId,
            ledgerName: data?.account?.ledgerName,
            hcurrDR: data?.homeCurrencyCredit,
            hcurrCR: data?.homeCurrencyDebit,
            lineDescription: data?.lineDescription,
          });
        }

        return data;
      });
      setRowData(ref);
      setOldRefData(JSON.parse(JSON.stringify(ref)));
    }
  };

  const getEuroRateValue = useCallback(
    async (
      date = moment(new Date()).format("YYYY-MM-DD"),
      allVouchers = voucherData
    ) => {
      // const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}api/${oAuthServiceConfig.dailyExchange}/base`;
      const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.dailyExchangeRate}/search/findByDate`;
      try {
        const list = await OAuthService.getList(url + "?date=" + date);
        if (list?.data) {
          const euroRateUpdated = Number(list?.data.euroRate).toFixed(4)
          // setAEDEuroRate(Number(list?.data[0].midpoint).toFixed(4));
          setAEDEuroRate(euroRateUpdated);
          setVoucherData({
            ...allVouchers,
            // euroRate: Number(list?.data[0].midpoint).toFixed(4),
            euroRate: euroRateUpdated,
          });
        } else {
          setEuroRateOpen(true);
          setAEDEuroRate("");
          setVoucherData({ ...allVouchers, euroRate: 0.00 });
        }
      } catch (error) {
        setEuroRateOpen(true);
        setAEDEuroRate("");
        setVoucherData({ ...allVouchers, euroRate: 0.00 });
      }
    },
    [voucherData, rowData]
  );

  const AllTransactions = async () => {
    if (allocationType === 'BANK_REF_NO') {
      let url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.allTransactions}`;
      url = url + `?customerNum=${voucherData.customer}`;
      const transactions = await OAuthService.getList(
        url
      );
      setAllocationRowDataCashReceipt(transactions.data);
    } else if (allocationType === 'OTHER_PAYABLES') {
      let url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.allTransactionsOtherPayables}`;
      url = url + `?accountNo=${voucherData.customer}`;
      const transactions = await OAuthService.getList(
        url
      );
      setAllocationRowDataCashReceipt(transactions.data);
    }

  };

  useEffect(() => {
    const currencies = async () => {
      const currencyUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.currencies}`;
      const list = await OAuthService.getList(currencyUrl);
      if (list?.data) {
        const options = list?.data?._embedded?.currencies.map((data) => {
          return { label: data.name, value: data.name };
        });
        setCurrencyOptions(options);
      }
    };
    currencies();

    const bankList = async () => {
      const bankUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.bankInfoes}`;
      const types = await OAuthService.getList(bankUrl);
      let banks = types?.data._embedded.bankInfoes.map((type) => {

        return { label: type.bank, value: type.bank, id: type.id }
      });
      if (banks && banks.length > 0) {
        setBankOptions(banks)
      }
    }
    bankList();

    const partnerOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      const partners = await OAuthService.getList(
        url +
        `/search/findByCustomerTypes?customerTypes=FRANCHISE&customerTypes=NOLTEFZE`
      );
      const result = partners?.data?._embedded?.companies.map((value) => {
        return {
          label: value.name,
          value: value.id,
          refNumber: value.vendorCustomerRef,
        };
      });
      setCompanyOptions(result);
    };
    partnerOpt();

    const customerOpt = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
      const partners = await OAuthService.getList(
        url +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE`
      );
      console.log(":: partners", partners)
      const result = partners?.data?._embedded?.companies.map((value) => {
        return {
          label: `${value.id}-${value.name}`,
          value: value.id,
          refNumber: value.vendorCustomerRef,
        };
      });
      setCustomerOptions(result);
    };
    customerOpt();

    const BankOptions = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.bankOptions}`;
      const bankOptions = await OAuthService.getList(
        url
      );
      console.log(":: bankOptions", bankOptions)
      const result = bankOptions.data?.map((value) => {
        return {
          label: `${value.bankName}`,
          value: value.accountNumber,
        };
      });
      console.log(":: result", result);
      setNFZEBankOptions(result);
    };
    BankOptions();

    const receiptTypeOptions = async () => {
      const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.receiptTypeOptions}`;
      const options = await OAuthService.getList(
        url
      );
      const optionsArr = options.data?._embedded?.receiptTypes;
      console.log(":: receipt type options", receiptTypeOptions)
      const result = optionsArr.map((value) => {
        return {
          label: `${value.type}`,
          value: value.type,
        }
      });
      console.log(":: result receipt type", result);
      setReceiptTypeOptions(result)
    };
    receiptTypeOptions();


    if (voucherData.customer) {
      AllTransactions();
    }

    if (params.id) {
      getEditData();
    } else if (params.viewid) {
      getEditData();
    } else {
      if (state) {
        setVoucherData({
          ...voucherData,
          voucherType: { id: state?.vouchertype },
          voucherReference: state?.refType,
          docDate: state?.docDate,
        });
        if (state?.refDocNo && state?.refType !== "NO_REFERENCE") {
          setDocRef(state?.refDocNo);
          getRefData(state?.refDocNo, state);
        }
        if (state?.refDocNo && state?.refType === "REVERSE_REFERENCE") {
          setAttachmentOpen(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (voucherData.customer) {
      AllTransactions();
    }
  }, [voucherData.customer, allocationType])

  const onBtAdd = useCallback(
    (event, data) => {
      let newRow = {
        account: ((data && data.length > 0) && (data[0]?.code + " " + data[0]?.name)) || "",
        accountNumber: ((data && data.length > 0) && data[0]?.code) || "",
        name: ((data && data.length > 0) && data[0]?.name) || "",
        subLegId: ((data && data.length > 0) && data[0]?.subLegId) || "",
        headId: ((data && data.length > 0) && data[0]?.headId) || "",
        headName: ((data && data.length > 0) && data[0]?.headName) || "",
        groupId: ((data && data.length > 0) && data[0]?.groupId) || "",
        groupName: ((data && data.length > 0) && data[0]?.groupName) || "",
        debit: 0.00,
        credit: 0.00,
        currency: voucherData.currency,
        exchangeRate:
          voucherData.currency === "EUR"
            ? 1.0000
            : Number(1 / voucherData.euroRate) <= 0
              ? 0.0000
              : Number(1 / voucherData.euroRate).toFixed(4),
        generalLedgerId:
          ((data && data.length > 0) && data[0]?.generalLedgerId) || "",
        generalLedgerName:
          ((data && data.length > 0) && data[0]?.generalLedgerName) || "",
        ledgerId: ((data && data.length > 0) && data[0]?.ledgerId) || "",
        ledgerName: ((data && data.length > 0) && data[0]?.ledgerName) || "",
        hcurrDR: 0.00,
        hcurrCR: 0.00,
        lineDescription: voucherData.docDescription,
      };
      setSaveDisable(true);
      const correctRowIndex = gridRef.current.api.applyTransaction({
        add: [newRow],
      });
      gridRef.current.api.refreshCells();
      let index = rowData.length;
      const nextIndex = index + 1;
      rowData.splice(nextIndex, 0, newRow);
      CountTotals();

      setTimeout(() => {
        gridRef.current.api.setFocusedCell("id");
        gridRef.current.api.startEditingCell({
          rowIndex: correctRowIndex.add[0].rowIndex,
          colKey: "account",
        });
      }, 800);
    },
    [rowData, voucherData]
  );

  useEffect(() => {
    if (voucherData.invoiceDocument) {
      const arr = voucherData.invoiceDocument.split('.');
      const val = arr[arr.length - 1];
      setShowView(allowedFormatToView.includes(val?.toLowerCase()))
    }
  }, [voucherData])

  const onRemoveRow = useCallback(
    (event) => {
      const selectedRow = gridRef.current.api.getSelectedRows();
      gridRef?.current?.api.applyTransaction({ remove: selectedRow });
      if (selectedRow[0]?.voucherId) {
        setRemovedTransaction([
          ...removedTransaction,
          selectedRow[0]?.voucherId,
        ]);
      }
      let index = rowData.findIndex(
        (row) => JSON.stringify(row) === JSON.stringify(event?.node?.data)
      );

      rowData.splice(index, 1);
      CountTotals();
      gridRef.current.api.refreshCells();
      CountTotals();
    },
    [rowData]
  );

  const onCellValueChanged = useCallback(
    (props) => {
      const data = props.data;
      const checkRows = [];
      const allData = [];
      props.api.forEachNode((node) => {
        node.data.credit = Number(node.data.credit).toFixed(2);
        node.data.debit = Number(node.data.debit).toFixed(2);
        if (
          !node.data.account ||
          node.data.account.trim() === "" ||
          ((node.data.credit === 0 || node.data.credit === "0.00") &&
            (node.data.debit === 0 || node.data.debit === "0.00"))
        ) {
          checkRows.push(node.data);
        }
        allData.push(node.data);
      });
      // const diff = totalDebits - totalCredits;
      const diff = (Math.abs(totalDebits - totalCredits).toFixed(2) === (Number(0).toFixed(2))) ? (Number(0).toFixed(2)) : Number(totalDebits - totalCredits).toFixed(2);

      if (
        voucherData.docDate &&
        voucherData.docDescription.trim() &&
        !validError.docDescription &&
        !validError.euroRate &&
        voucherData.currency &&
        allData.length > 0 &&
        diff === (Number(0).toFixed(2)) &&
        !params.viewid
      ) {
        if (voucherData.invoiceDocument) {
          if (voucherData.invoiceDate && voucherData.invoiceNo) {
            if (checkRows.length > 0) {
              setSaveDisable(true);
            } else {
              if (params.id) {
                if (
                  JSON.stringify(oldEditData) !== JSON.stringify(voucherData) ||
                  JSON.stringify(oldEditRowData) !== JSON.stringify(allData)
                ) {
                  setSaveDisable(false);
                } else {
                  setSaveDisable(true);
                }
              } else {
                setSaveDisable(false);
              }
            }
          } else {
            setSaveDisable(true);
          }
        } else {
          if (checkRows.length > 0) {
            setSaveDisable(true);
          } else {
            if (params.id) {
              if (
                JSON.stringify(oldEditRowData) !== JSON.stringify(allData) ||
                JSON.stringify(oldEditData) !== JSON.stringify(voucherData)
              ) {
                setSaveDisable(false);
              } else {
                setSaveDisable(true);
              }
            } else {
              setSaveDisable(false);
            }
          }
        }
      } else {
        setSaveDisable(true);
      }
      data.debit = Number(data.debit).toFixed(2);
      data.credit = Number(data.credit).toFixed(2);
      data.hcurrCR =
        voucherData.euroRate === 0
          ? 0.00 : Number(data.credit / voucherData.euroRate) !== 0
            ? Number(data.credit / voucherData.euroRate).toFixed(2)
            : 0.00;
      data.hcurrDR =
        voucherData.euroRate === 0
          ? 0.00 : Number(data.debit / voucherData.euroRate) !== 0
            ? Number(data.debit / voucherData.euroRate).toFixed(2)
            : 0.00;
      data.exchangeRate = Number(data.exchangeRate).toFixed(4);
      data.hcurrCR = Number(data.hcurrCR).toFixed(2);
      data.hcurrDR = Number(data.hcurrDR).toFixed(2);
      data.credit = Number(data.credit).toFixed(2);
      data.debit = Number(data.debit).toFixed(2);
      CountTotals();
      gridRef.current.api.refreshCells();
    },
    [
      voucherData,
      rowData,
      totalDebits,
      totalCredits,
      oldEditData,
      oldEditRowData,
      validError,
    ]
  );

  useEffect(() => {
    const updatedData = rowData?.map((data) => {
      data.currency = voucherData.currency
      data.exchangeRate = voucherData.euroRate === 0 ? 0.00 : Number(1 / voucherData.euroRate).toFixed(4)
      data.hcurrCR = voucherData.euroRate === 0 ? 0.00 : Number(data.credit / voucherData.euroRate) !== 0 ? Number(data.credit / voucherData.euroRate).toFixed(2) : 0.00;
      data.hcurrDR = voucherData.euroRate === 0 ? 0.00 : Number(data.debit / voucherData.euroRate) !== 0 ? Number(data.debit / voucherData.euroRate).toFixed(2) : 0.00;
      data.exchangeRate = Number(data.exchangeRate).toFixed(4);
      data.hcurrCR = Number(data.hcurrCR).toFixed(2);
      data.hcurrDR = Number(data.hcurrDR).toFixed(2);
      data.credit = Number(data.credit).toFixed(2);
      data.debit = Number(data.debit).toFixed(2);
      return data;
    });
    setRowData(updatedData)
    CountTotals();
  }, [voucherData.euroRate])

  const CountTotals = useCallback(() => {
    debugger;
    let debitsTotal = 0.00;
    let creditTotal = 0.00;
    rowData.map((value) => {
      debitsTotal = debitsTotal + Number(value.debit);
      creditTotal = creditTotal + Number(value.credit);
      return value;
    });
    setTotalDebits(debitsTotal);
    setTotalCredits(creditTotal);
  }, [rowData]);

  const countTotalAllocationData = useCallback(() => {
    console.log(":: allocation data changed");
    const newAllocationTotal = allocationRowDataCashReceipt.reduce((prevValue, curr) => {
      debugger;
      let val = prevValue;
      console.log(":: curr", curr)
      if (curr) {
        val = prevValue + curr.allocated;
      }
      return val;
    }, 0);
    console.log(":: new allocation data", newAllocationTotal);
    setTotalAllocated(newAllocationTotal);
  }, [allocationRowDataCashReceipt])

  useEffect(() => {
    CountTotals();
  }, [rowData]);

  useEffect(() => {
    countTotalAllocationData();
  }, [allocationRowDataCashReceipt]);

  const columnTypes = useMemo(() => {
    return {
      editableColumn: {
        editable: (params) => {
          return isCellEditable(params);
        },
      },
    };
  }, []);

  useEffect(() => {
    // const diff = totalDebits - totalCredits;
    const diff = (Math.abs(totalDebits - totalCredits).toFixed(2) === (Number(0).toFixed(2))) ? (Number(0).toFixed(2)) : Number(totalDebits - totalCredits).toFixed(2);
    if (state?.vouchertype === "64b149201bcd0a6179acbf0e") {
      setSaveDisable(false);
    } else if (state?.vouchertype === "650d3389c11f3c7fa34e084b") {
      if (
        voucherData.docDate &&
        !validError.docDescription &&
        !validError.euroRate &&
        voucherData.currency &&
        voucherData.docDescription.trim() &&
        rowData.length > 0 &&
        voucherData.customer &&
        voucherData.amountReceived && voucherData.amountReceived !== 0 &&
        parseInt(diff) === 0 &&
        // totalCredits === totalAllocated &&
        !params.viewid
      ) {
        setSaveDisable(false)
      }
    } else {
      if (
        voucherData.docDate &&
        !validError.docDescription &&
        !validError.euroRate &&
        voucherData.currency &&
        voucherData.docDescription.trim() &&
        rowData.length > 0 &&
        diff === (Number(0).toFixed(2)) &&
        !params.viewid
      ) {
        if (voucherData.invoiceDocument) {
          if (voucherData.invoiceDate && voucherData.invoiceNo) {
            let checkRows = rowData.filter(
              (data) =>
                !data.account ||
                data.account.trim() === "" ||
                ((data.credit === 0 || data.credit === "0.00") &&
                  (data.debit === 0 || data.debit === "0.00"))
            );
            if (checkRows.length > 0) {
              setSaveDisable(true);
            } else {
              if (params.id) {
                if (
                  JSON.stringify(oldEditData) !== JSON.stringify(voucherData) ||
                  JSON.stringify(oldEditRowData) !== JSON.stringify(rowData)
                ) {
                  setSaveDisable(false);
                } else {
                  setSaveDisable(true);
                }
              } else {
                setSaveDisable(false);
              }
            }
          } else {
            setSaveDisable(true);
          }
        } else {
          let checkRows = rowData.filter(
            (data) =>
              !data.account ||
              data.account.trim() === "" ||
              ((data.credit === 0 || data.credit === "0.00") &&
                (data.debit === 0 || data.debit === "0.00"))
          );
          if (checkRows.length > 0) {
            setSaveDisable(true);
          } else {
            if (params.id) {
              if (
                JSON.stringify(oldEditData) !== JSON.stringify(voucherData) ||
                JSON.stringify(oldEditRowData) !== JSON.stringify(rowData)
              ) {
                setSaveDisable(false);
              } else {
                setSaveDisable(true);
              }
            } else {
              setSaveDisable(false);
            }
          }
        }
      } else {
        setSaveDisable(true);
      }
    }

  }, [
    voucherData,
    rowData,
    totalDebits,
    totalCredits,
    oldEditData,
    oldEditRowData,
    validError,
  ]);

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    setVoucherData({
      ...voucherData,
      invoiceDocument: file.name,
      invoiceDate: voucherData.docDate,
    });
    setDocumentFile(file);
  };

  const removeDocument = () => {
    setVoucherData({ ...voucherData, invoiceDocument: "" });
    setDocumentFile([]);
  };

  const handleDownloadAttachment = async () => {
    const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;
    const download = await OAuthService.getDownload(
      downloadUrl + `/${voucherData.invoiceDocument}`
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = voucherData.invoiceDocument;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  const handleCellKeyDown = (event) => {
    if (event.event.key === 'Insert') {
      onBtAdd();
    }
  }

  const getContextMenuItems = useCallback(
    (event) => {
      const result = [
        {
          name: "Add Transaction",
          icon: '<span><i class="material-icons style="font-size: 18px">add</i></span>',
          action: () => {
            onBtAdd(event);
          },
        },
        {
          name: "Remove Transaction",
          icon: '<span><i class="material-icons style="font-size: 18px">delete</i></span>',
          disabled: selectedRows.length > 0 ? false : true,
          action: () => {
            onRemoveRow(event);
          },
        },
        "separator",
        "export",
        "chartRange",
      ];
      if (params.viewid) {
        return "";
      } else {
        return result;
      }
    },
    [selectedRows, rowData, voucherData]
  );

  const DrawerOpen = async () => {
    setDrawer(true);
    const list = await OAuthService.getList(voucherUrl + "/searchSubLedger");
    const subledger = list.data.map((value) => {
      value.fullname = value.code + " " + value.name;
      return value;
    });
    setSubLedgrOptions(subledger);
  };

  const handleDrawerClose = () => {
    setDrawer(false);
  };

  const handleSearchBarChange = async (event) => {
    const search = event.target.value;
    const list = await OAuthService.getList(
      voucherUrl + "/searchSubLedger?name=" + search
    );
    const subledger = list.data.map((value) => value.code + " " + value.name);
    setSubLedgrOptions(subledger);
  };

  const isCellEditable = useCallback((params) => {
    if ((params.data.debit > 0 || params.data.debit < 0) && params.column.colId === "credit") {
      return false;
    } else if ((params.data.credit > 0 || params.data.credit < 0) && params.column.colId === "debit") {
      return false;
    } else {
      return true;
    }
  }, []);

  const handleAttachmentClose = () => {
    setCheckAttachment("no");
    setAttachmentOpen(false);
    setVoucherData({ ...voucherData, invoiceDocument: "" });
  };
  const handleAttachmentSubmit = () => {
    setCheckAttachment("yes");
    setAttachmentOpen(false);
  };

  function dragover_handler(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = "move";
  }

  function drop_handler(ev, box, id) {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text/plain");
    if (id === "accountList") {
      const filterData = subLedgrOptions.filter(
        (ledger) => ledger.fullname === data
      );
      onBtAdd(ev, filterData);
    }
  }

  function dragstart_handler(ev) {
    // Add the target element's id to the data transfer object
    ev.dataTransfer.setData("text/plain", ev.target.id);
    ev.dataTransfer.effectAllowed = "move";
  }

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Main open={drawer}>
          <FormPageHeader
            currentPage={
              params.id
                ? "Edit " +
                (rowData.length > 0
                  ? rowData[0]?.voucherType?.description
                    ? rowData[0]?.voucherType?.description
                    : "Voucher"
                  : "Voucher")
                : params.viewid
                  ? "View " +
                  (rowData.length > 0
                    ? rowData[0]?.voucherType?.description
                      ? rowData[0]?.voucherType?.description
                      : "Voucher"
                    : "Voucher")
                  : "Add " +
                  (state?.voucherTypeDesc ? state?.voucherTypeDesc : "Voucher")
            }
            handleSubmit={handleSubmit}
            componentName={"Voucher"}
            handleCancel={handleCancel}
            error={error}
            successMsg={successMsg}
            snackState={snackState}
            saveDisable={saveDisable}
            showLedgersList={DrawerOpen}
          />
          <Box className="m-10" sx={{ p: 2, border: "1px dashed grey" }}>
            {state?.vouchertype === "64b149201bcd0a6179acb0e" ? (
              <>
                <div>
                  <Grid container spacing={2}>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className=" basis-0 float-left">
                          Payment Type
                        </label>
                        {/* <FormControl sx={{ width: 200 }} > */}
                        <Select
                          name="payment_Type"
                          // value={(currencyOptions.length > 0 && voucherData.currency) && currencyOptions.filter((data) => data.value === voucherData.currency)}
                          // error={validError.currency ? true : false}
                          // onChange={handleChangeCurrency}
                          // isDisabled={params.viewid ? true : false}
                          //options={currencyOptions}
                          styles={customStyles()}
                        ></Select>
                        {/* </FormControl> */}
                        {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">*Doc Date</label>
                        <CustomDatePicker
                          className="w-[100%]"
                          format={"dd-MM-yyyy"}
                          name={"docdate"}
                          value={voucherData.docDate}
                          handleChange={handleDateChange}
                          error={validError.docdate ? true : false}
                          disabled={params.viewid ? true : false}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              InputLabelProps={{}}
                              {...params}
                              sx={{
                                backgroundColor: props.viewData && "#8080800f",
                              }}
                              InputProps={{
                                readOnly: params.viewid ? true : false,
                              }}
                            />
                          )}
                        />
                        <Typography className="text-[#f44336] text-sm ml-14">
                          {checksubmit && !voucherData.docDate
                            ? "This field is required"
                            : validError.docdate}
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className=" basis-0 float-left">
                          Voucher Currency
                        </label>
                        {/* <FormControl sx={{ width: 200 }} > */}
                        <Select
                          name="vouchertype"
                          // value={(currencyOptions.length > 0 && voucherData.currency) && currencyOptions.filter((data) => data.value === voucherData.currency)}
                          // error={validError.currency ? true : false}
                          // onChange={handleChangeCurrency}
                          // isDisabled={params.viewid ? true : false}
                          //options={currencyOptions}
                          styles={customStyles()}
                        ></Select>
                        {/* </FormControl> */}
                        {/* <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.currency) ? "This field is required" : validError.currency}</Typography> */}
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">Euro Rate</label>
                        <TextField
                          className="w-[100%]"
                          name="eurorate"
                        //error={validError.euroRate ? true : false}
                        // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                        //value={voucherData.euroRate}
                        // helperText={validError.euroRate}
                        // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                        // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">
                          Posting Date
                        </label>
                        <TextField
                          name={"postdate"}
                          // value={moment(voucherData.postDate && (params.id || params.viewid) ? voucherData.postDate : new Date(), 'YYYY-MM-DD').format('DD-MM-YYYY')}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2} className="mt-8">
                    <Grid item xs={4}>
                      <Stack>
                        <label className="basis-0 float-left">Vendor</label>
                        <Select
                          name="vendor"
                          //value={(voucherData.companyCode && companyOptions) && companyOptions.filter((data) => Number(data.value) === Number(voucherData.companyCode))}
                          // onChange={handleCompanyChange}
                          // isDisabled={params.viewid ? true : false}
                          //options={companyOptions}
                          styles={customStyles()}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={4}>
                      <Stack>
                        <label className="basis-0 float-left">Name</label>
                        <TextField
                          className="w-[100%]"
                          name="name"
                        // value={voucherData.invoiceNo}
                        // error={validError?.invoiceNo ? true : false}
                        // onChange={(params) => { handleinvoiceNoChange(params); setValidError({ ...validError, invoiceNo: checkNumber(params.target.value) }) }}
                        // helperText={validError?.invoiceNo}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4}>
                      <Stack>
                        <label className="basis-0 float-left">
                          Doc Description
                        </label>
                        <TextField
                          // className="w-[30%]"
                          name="docdescription"
                        //value={voucherData.docDescription}
                        //error={validError.docDescription ? true : false}
                        //helperText={validError.docDescription}
                        // onChange={(params) => { handleDocDescriptionChange(params); setValidError({ ...validError, docDescription: checkSpecialChar(params.target.value) }) }}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
                <div>
                  <Grid container spacing={2} className="mt-8">
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className=" basis-0 float-left">*Bank</label>
                        {/* <FormControl sx={{ width: 200 }} > */}
                        <Select
                          name="bank"
                          error={validError.bank ? true : false}
                          styles={customStyles()}
                        ></Select>
                        {/* </FormControl> */}
                        <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.bank) ? "This field is required" : validError.bank}</Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">Euro Rate</label>
                        <TextField
                          className="w-[100%]"
                          name="eurorate"
                        //error={validError.euroRate ? true : false}
                        // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                        //value={voucherData.euroRate}
                        // helperText={validError.euroRate}
                        // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                        // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">Chq NO</label>
                        <TextField
                          className="w-[100%]"
                          name="eurorate"
                        //error={validError.euroRate ? true : false}
                        // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                        //value={voucherData.euroRate}
                        // helperText={validError.euroRate}
                        // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                        // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">*Amount</label>
                        <TextField
                          className="w-[100%]"
                          name="eurorate"
                          error={validError.ammount ? true : false}
                        // onChange={(params) => { handleEuroChange(params); setValidError({ ...validError, euroRate: checkNumber(event.target.value) }) }}
                        //value={voucherData.euroRate}
                        // helperText={validError.euroRate}
                        // disabled={params.viewid ? true : (voucherData.currency === 'USD' || voucherData.currency === 'OTHER' || (voucherData.currency === 'AED' && !AEDEuroRate)) ? false : true}
                        // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                        />
                        <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.amount) ? "This field is required" : validError.amount}</Typography>
                      </Stack>
                    </Grid>
                    <Grid item xs={2.4}>
                      <Stack>
                        <label className="basis-0 float-left">Curr</label>
                        <TextField
                          name={"postdate"}
                          // value={moment(voucherData.postDate && (params.id || params.viewid) ? voucherData.postDate : new Date(), 'YYYY-MM-DD').format('DD-MM-YYYY')}
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Stack>
                    </Grid>
                  </Grid>

                  {/* <Grid container spacing={2} className="mt-5">
                        <Grid item xs={6} >
                            <Stack>
                                <label className="basis-0 float-left">Doc Description</label>
                                <TextField
                                    // className="w-[30%]"
                                    name='docdescription'
                                //value={voucherData.docDescription}
                                //error={validError.docDescription ? true : false}
                                //helperText={validError.docDescription}
                                // onChange={(params) => { handleDocDescriptionChange(params); setValidError({ ...validError, docDescription: checkSpecialChar(params.target.value) }) }}

                                />
                            </Stack>
                        </Grid>

                    </Grid> */}
                </div>
              </>
            ) : (
              <>
                <div>
                  <Grid container spacing={2}>
                    {(state?.vouchertype == '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b') && <Grid item xs={2}>
                      <Stack>
                        <label className=" basis-0 float-left">
                          *Receipt Type
                        </label>
                        {/* <FormControl sx={{ width: 200 }} > */}
                        <Select
                          name="receiptType"
                          value={
                            receiptTypeOptions.length > 0 &&
                            voucherData.receiptType &&
                            receiptTypeOptions.filter(
                              (data) => data.value === voucherData.receiptType
                            )
                          }
                          error={validError.receiptType ? true : false}
                          onChange={handleChangeReceiptType}
                          isDisabled={params.viewid ? true : false}
                          options={receiptTypeOptions}
                          styles={customStyles()}
                        ></Select>
                        {/* </FormControl> */}
                        <Typography className="text-[#f44336] text-sm ml-14">
                          {checksubmit && !voucherData.currency
                            ? "This field is required"
                            : validError.currency}
                        </Typography>
                      </Stack>
                    </Grid>}
                    <Grid item xs={2}>
                      <Stack>
                        <label className="basis-0 float-left">Doc Number</label>
                        <TextField
                          className="w-[100%]"
                          name="docno"
                          value={voucherData.voucherNo ? voucherData.docRef : ''}
                          disabled
                          style={{
                            backgroundColor: "rgba(255, 255, 255, 0.12)",
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                        // onChange={handle}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={2}>
                      <Stack>
                        <label className="basis-0 float-left">*Doc Date </label>
                        <CustomDatePicker
                          className="w-[100%]"
                          format={"dd-MM-yyyy"}
                          name={"docdate"}
                          value={voucherData.docDate}
                          handleChange={handleDateChange}
                          error={validError.docdate ? true : false}
                          disabled={params.viewid ? true : false}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              InputLabelProps={{}}
                              {...params}
                              sx={{
                                backgroundColor: props.viewData && "#8080800f",
                              }}
                              InputProps={{
                                readOnly: params.viewid ? true : false,
                              }}
                            />
                          )}
                        />
                        <Typography className="text-[#f44336] text-sm ml-14">
                          {checksubmit && !voucherData.docDate
                            ? "This field is required"
                            : validError.docdate}
                        </Typography>
                      </Stack>
                    </Grid>
                    {!(state?.vouchertype === '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b') && <Grid item xs={2}>
                      <Stack>
                        <label className=" basis-0 float-left">
                          *Voucher Currency
                        </label>
                        {/* <FormControl sx={{ width: 200 }} > */}
                        <Select
                          name="vouchertype"
                          value={
                            currencyOptions.length > 0 &&
                            voucherData.currency &&
                            currencyOptions.filter(
                              (data) => data.value === voucherData.currency
                            )
                          }
                          error={validError.currency ? true : false}
                          onChange={handleChangeCurrency}
                          isDisabled={params.viewid ? true : false}
                          options={currencyOptions}
                          styles={customStyles()}
                        ></Select>
                        {/* </FormControl> */}
                        <Typography className="text-[#f44336] text-sm ml-14">
                          {checksubmit && !voucherData.currency
                            ? "This field is required"
                            : validError.currency}
                        </Typography>
                      </Stack>
                    </Grid>}
                    <Grid item xs={2}>
                      <Stack>
                        <label className="basis-0 float-left">*Euro Rate</label>
                        <TextField
                          className="w-[100%]"
                          name="eurorate"
                          error={validError.euroRate ? true : false}
                          onChange={(params) => {
                            handleEuroChange(params);
                            setValidError({
                              ...validError,
                              euroRate: checkNumber(params.target.value),
                            });
                          }}
                          value={voucherData?.euroRate}
                          helperText={validError.euroRate}
                          disabled={params.viewid ? true : false}
                        // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                        />
                      </Stack>
                    </Grid>

                    <Grid item xs={2}>
                      {(voucherData.voucherReference === "WITH_REFERENCE" ||
                        voucherData.voucherReference ===
                        "REVERSE_REFERENCE") && (
                          <Stack>
                            <label className="basis-0 float-left">Doc Ref</label>
                            <TextField
                              className="w-[100%]"
                              name="docRef"
                              value={docRef || voucherData?.refDocNo}
                              disabled
                              style={{
                                backgroundColor: "rgba(255, 255, 255, 0.12)",
                              }}
                            />
                          </Stack>
                        )}
                    </Grid>
                    <Grid item xs={2}>
                      <Stack>
                        <label className="basis-0 float-left">
                          Posting Date
                        </label>
                        <TextField
                          name={"postdate"}
                          value={moment(
                            voucherData.postDate && (params.id || params.viewid)
                              ? voucherData.postDate
                              : new Date(),
                            "YYYY-MM-DD"
                          ).format("DD-MM-YYYY")}
                          InputProps={{
                            readOnly: true,
                          }}
                          disabled
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                </div>
              </>)}

            {state?.voucherTypeDesc === 'Bank Payment' && <><div>
              <Grid container spacing={2} className="mt-8">
                <Grid item xs={2}>
                  <Stack>
                    <label className=" basis-0 float-left">
                      Payment Type
                    </label>
                    <Select
                      name="payment_Type"
                      options={paymentTypeOptions}
                      value={(voucherData?.paymentType && paymentTypeOptions.length > 0) && paymentTypeOptions.filter((data) => data.value === voucherData?.paymentType)}
                      onChange={handlePaymentTypeChange}
                      styles={customStyles()}
                    ></Select>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Stack>
                    <label className=" basis-0 float-left">
                      Vendor Name
                    </label>
                    <TextField
                      value={voucherData?.vendorName}
                      onChange={handleVendorNameChange}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Stack>
                    <label className=" basis-0 float-left">
                      Vendor Code
                    </label>
                    <TextField
                      value={voucherData?.vendorCode}
                      onChange={handleVendorCodeChange}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </div>
              <div>
                <Grid container spacing={2} className="mt-8">
                  <Grid item xs={2}>
                    <Stack>
                      <label className=" basis-0 float-left">
                        Bank
                      </label>
                      <Select
                        name="bank"
                        options={bankOptions}
                        value={(voucherData?.bank && bankOptions.length > 0) && bankOptions.filter((data) => data?.value === voucherData?.bank)}
                        onChange={handleBankChange}
                        styles={customStyles()}
                      ></Select>
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <Stack>
                      <label className=" basis-0 float-left">
                        Chq No
                      </label>
                      <TextField
                        value={voucherData?.chq}
                        onChange={handleChqNoChange}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <Stack>
                      <label className=" basis-0 float-left">
                        Amount
                      </label>
                      <TextField
                        value={voucherData?.amount}
                        onChange={handleAmountChange}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </div></>}
            {!(state?.vouchertype === '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b') && <div>
              <Grid container spacing={2} className="mt-8">
                <Grid item xs={2}>
                  <Stack>
                    <label className="basis-0 float-left">*Company</label>
                    <Select
                      name="company"
                      value={
                        voucherData.companyCode &&
                        companyOptions &&
                        companyOptions.filter(
                          (data) =>
                            Number(data.value) ===
                            Number(voucherData.companyCode)
                        )
                      }
                      // onChange={handleCustomerC}
                      isDisabled={params.viewid ? true : false}
                      options={companyOptions}
                      styles={customStyles()}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <Stack>
                    <label className="basis-0 float-left">
                      {voucherData?.invoiceDocument && "*"}Invoice No
                    </label>
                    <TextField
                      className="w-[100%]"
                      name="invoiceNo"
                      value={voucherData.invoiceNo}
                      error={validError?.invoiceNo ? true : false}
                      onChange={(params) => {
                        handleinvoiceNoChange(params);
                      }}
                      helperText={validError?.invoiceNo}
                      InputProps={{
                        readOnly: params.viewid ? true : false,
                      }}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={2}>
                  <Stack>
                    <label className="basis-0 float-left">
                      {voucherData?.invoiceDocument && "*"}Invoice Date
                    </label>
                    <CustomDatePicker
                      className="w-[100%]"
                      format={"dd-MM-yyyy"}
                      name={"invoiceDate"}
                      value={voucherData.invoiceDate}
                      error={validError.invoiceDate ? true : false}
                      maxDate={new Date()}
                      handleChange={handleinvoiceDateChange}
                      disabled={true}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          InputLabelProps={{}}
                          {...params}
                          sx={{
                            backgroundColor: props.viewData && "#8080800f",
                          }}
                        />
                      )}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2} className="flex flex-col">
                  <label className="basis-0 float-left">
                    Invoice Attachment
                  </label>
                  <Tooltip title={"Attachment"}>
                    {voucherData?.invoiceDocument ? (
                      <Typography className="flex flex-row items-center	">
                        <Grid className="flex">
                          <div>
                            <FileCopyIcon
                              fontSize={"large"}
                              color="warning"
                              className=" mt-10"
                            />
                          </div>
                          <div>
                            <Typography
                              fontSize={"large"}
                              className="ml-12 mt-5"
                            >
                              {voucherData?.invoiceDocument}
                            </Typography>
                          </div>
                        </Grid>
                        <Button
                          className="mt-10"
                          onClick={handleDownloadAttachment}
                        >
                          <FuseSvgIcon>material-solid:download</FuseSvgIcon>
                        </Button>
                        {showView && <Button
                          className="mt-10"
                          onClick={() => setOpen(true)}
                        >
                          <FuseSvgIcon>material-solid:remove_red_eye</FuseSvgIcon>
                        </Button>}
                        {!params.viewid && (
                          <>
                            <FuseSvgIcon
                              className="mt-5 w-32 h-32 cursor-pointer"
                              onClick={() => removeDocument()}
                            >
                              heroicons-outline:x
                            </FuseSvgIcon>
                          </>
                        )}
                      </Typography>
                    ) : (
                      <Button
                        variant="contained"
                        color="warning"
                        className="mt-10 max-w-fit"
                        disabled={params.viewid ? true : false}
                        onClick={handleSubmitAttachment}
                      >
                        <FuseSvgIcon>
                          material-outline:attachment
                        </FuseSvgIcon>
                      </Button>
                    )}
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="mt-5">
                <Grid item xs={6}>
                  <Stack>
                    <label className="basis-0 float-left">
                      *Doc Description
                    </label>
                    <TextField
                      // className="w-[30%]"
                      name="docdescription"
                      value={voucherData.docDescription}
                      error={validError.docDescription ? true : false}
                      helperText={validError.docDescription}
                      onChange={(params) => {
                        handleDocDescriptionChange(params);
                        setValidError({
                          ...validError,
                          docDescription: checkSpecialChar(
                            params.target.value
                          ),
                        });
                      }}
                      InputProps={{
                        readOnly: params.viewid ? true : false,
                      }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </div >}
            {
              (state?.vouchertype === '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b') && <div>
                <Grid container spacing={2} className="mt-1">
                  <Grid item xs={4}>
                    <Stack>
                      <label className="basis-0 float-left">*Customer</label>
                      {customerOptions && <Select
                        name="customer"
                        value={
                          voucherData.customer &&
                          customerOptions &&
                          customerOptions.filter(
                            (data) =>
                              Number(data.value) ===
                              Number(voucherData.customer || '0')
                          )
                        }
                        onChange={handleCustomerChange}
                        isDisabled={params.viewid ? true : false}
                        options={customerOptions}
                        styles={customStyles()}
                      />}
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <Stack>
                      <label className="basis-0 float-left">*Bank</label>
                      <Select
                        name="Bank"
                        value={
                          voucherData.NFZEbank &&
                          NFZEbankOptions &&
                          NFZEbankOptions.filter(
                            (data) =>
                              Number(data.value) ===
                              Number(voucherData.NFZEbank)
                          )
                        }
                        onChange={handleBankNFZChange}
                        isDisabled={params.viewid ? true : false}
                        options={NFZEbankOptions}
                        styles={customStyles()}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <Stack>
                      <label className="basis-0 float-left">*Amount Received</label>
                      <TextField
                        className="w-[100%]"
                        name="docno"
                        value={voucherData.amountReceived ?? ''}
                        onChange={handleAmountReceivedChange}
                        isDisabled={params.viewid ? true : false}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={2}>
                    <Stack>
                      <label className="basis-0 float-left">Bank charges</label>
                      <TextField
                        className="w-[100%]"
                        isDisabled={params.viewid ? true : false}
                        name="docno"
                        value={voucherData.bankCharges ?? ''}
                        onChange={handleBankChargesChange}
                      />
                    </Stack>

                  </Grid>
                  <Grid item xs={6}>
                    <Stack>
                      <label className="basis-0 float-left">
                        *Doc Description
                      </label>
                      <TextField
                        // className="w-[30%]"
                        name="docdescription"
                        value={voucherData.docDescription}
                        error={validError.docDescription ? true : false}
                        helperText={validError.docDescription}
                        onChange={(params) => {
                          handleDocDescriptionChange(params);
                          setValidError({
                            ...validError,
                            docDescription: checkSpecialChar(
                              params.target.value
                            ),
                          });
                        }}
                        InputProps={{
                          readOnly: params.viewid ? true : false,
                        }}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControlLabel
                      control={
                        <Checkbox onChange={handleBankChargesToClientChange} name="bankCharge" value={'BANK_CHARGE_TO_CLIENT'} />
                      }
                      sx={{ ml: '-3px' }}
                      label="Back Charge to Client"
                      isDisabled={params.viewid ? true : false}
                    />
                  </Grid>

                </Grid>
              </div>
            }

          {/* </Box>
            )} */}
      </Box >
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleFormClose}
        open={formOpen}
      >
        <DialogTitle>{"Upload documents"}</DialogTitle>
        <DialogContent>
          {!voucherData.invoiceDocument ? (
            <Stack className="w-full mb-16">
              <Box
                className="flex justify-center items-center"
                sx={{
                  height: 180,
                  border: "1px dotted grey",
                }}
              >
                <CloudUploadIcon fontSize={"large"} />
                <Typography className="ml-12">Upload your image</Typography>
                <Button
                  variant="contained"
                  component="label"
                  color="warning"
                  className="ml-12"
                >
                  <input
                    hidden
                    type="file"
                    onChange={(e) => handleDocumentChange(e)}
                  />
                  <Typography color="black">Browse</Typography>
                </Button>
              </Box>
            </Stack>
          ) : (
            <Stack className="w-full mb-16">
              <Box className="flex justify-between">
                <Grid className="flex">
                  <div>
                    <FileCopyIcon
                      fontSize={"large"}
                      color="warning"
                      className=" mt-20"
                    />
                  </div>
                  <div>
                    <Typography fontSize={"large"} className="ml-12 mt-20">
                      {voucherData?.invoiceDocument}
                    </Typography>
                  </div>
                </Grid>
                <Grid>
                  <FuseSvgIcon
                    className="mt-20 w-32 h-32 cursor-pointer"
                    onClick={() => removeDocument()}
                  >
                    heroicons-outline:x
                  </FuseSvgIcon>
                </Grid>
              </Box>
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFormClose}>Close</Button>
        </DialogActions>
      </Dialog>
      {state?.vouchertype === "64b149201bcd0a6179acb0e" ? (
            <>
              inside condition
              <Grid container spacing={2}>
                <Grid item xs={7}>
                  <div className="mt-20">
                    <Stack className="mt-20" style={{ height: "300px" }}>
                      <Box
                        id="accountListGrid"
                        onDrop={(event) =>
                          drop_handler(event, "container-right", "accountList")
                        }
                        onDragOver={(event) => dragover_handler(event)}
                        style={{ height: '300px' }}
                      >
                        <AgGridTable
                          rowData={rowData}
                          columnDefs={columnDefs}
                          onGridReady={onGridReady}
                          rowGroupPanelShow="never"
                          gridRef={gridRef}
                          columnTypes={columnTypes}
                          onSelectionChanged={onSelectionChanged}
                          onCellValueChanged={onCellValueChanged}
                          getContextMenuItems={getContextMenuItems}
                          floatingFilter={false}
                        />
                      </Box>
                    </Stack>
                    <Box
                      className="p-8 m-8"
                      sx={{ pb: 1, border: "1px dashed grey" }}
                    >
                      <Grid
                        container
                        spacing={2}
                        className="justify-center mt-1"
                      >
                        <Grid item xs={2}>
                          <label className="basis-0 float-left">
                            Total Debits :
                          </label>
                          <TextField
                            className="w-[100%]"
                            name="totalDebits"
                            value={"150,000.00"}
                            // value={totalDebits}
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <label className="basis-0 float-left">
                            Total Credits :
                          </label>
                          <TextField
                            className="w-[100%]"
                            name="totalCredits"
                            value={"150,000.00"}
                            //value={totalCredits}
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <label className=" basis-0 float-left">Diff :</label>
                          <TextField
                            className="w-[100%]"
                            name="eurorate"
                            size="small"
                            value={0}
                            //value={totalDebits - totalCredits}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2} className="mt-20">
                          <TextField
                            className="w-[100%]"
                            name="AED"
                            value={"150,000.00"}
                            // value={voucherData.currency}
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2} className="mt-20">
                          <TextField
                            className="w-[100%]"
                            name="rate"
                            value={1}
                            //value={voucherData.euroRate}
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        spacing={2}
                        className="justify-center mt-5"
                      >
                        <Grid item xs={2}>
                          <TextField
                            className="w-[100%]"
                            name="convertedDebits"
                            size="small"
                            value={"150,000.00"}
                            //value={voucherData.euroRate === 0 ? 0 : Number(totalDebits / voucherData.euroRate).toFixed(2)}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <TextField
                            className="w-[100%]"
                            name="convertedCredits"
                            size="small"
                            value={"150,000.00"}
                            //value={voucherData.euroRate === 0 ? 0 : Number(totalCredits / voucherData.euroRate).toFixed(2)}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <TextField
                            className="w-[100%]"
                            name="diff"
                            size="small"
                            value={0}
                            // value={voucherData.euroRate === 0 ? 0 : Number(totalDebits / voucherData.euroRate).toFixed(2) - Number(totalCredits / voucherData.euroRate).toFixed(2)}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}>
                          <TextField
                            className="w-[100%]"
                            name="EUR"
                            value="EUR"
                            size="small"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </Grid>

                        <Grid item xs={2}></Grid>
                      </Grid>
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div className="mt-20" style={{ height: "300px" }}>
                    <AgGridTable
                      rowData={allocationRowData}
                      columnDefs={allocationColumnDefs}
                      //   onGridReady={onGridReady}
                      rowGroupPanelShow="never"
                      //  onSelectionChanged={onSelectionChanged}
                      // onCellValueChanged={onCellValueChanged}
                      //  getContextMenuItems={getContextMenuItems}
                      floatingFilter={false}
                    />
                    <Box
                      className="p-8 m-8 "
                      sx={{ pb: 1, border: "1px dashed grey" }}
                    >
                      <Grid
                        container
                        spacing={2}
                        className="justify-center mt-1"
                      >
                        <Grid item xs={4}>
                          <Stack>
                            <label className="basis-0 float-left">
                              Amount To Be Allocated
                            </label>
                            <TextField
                              className="w-[100%]"
                              name="amount"
                              value={"150,000.00"}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Stack>
                        </Grid>

                        <Grid item xs={4}>
                          <Stack>
                            <label className="basis-0 float-left">
                              Allocated
                            </label>
                            <TextField
                              className="w-[100%]"
                              name="allocated"
                              value={"150,000.00"}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Stack>
                        </Grid>

                        <Grid item xs={4}>
                          <Stack>
                            <label className="basis-0 float-left">Balace</label>
                            <TextField
                              className="w-[100%]"
                              name="balance"
                              value={"-"}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </>
          ) : ((state?.vouchertype === '650d3389c11f3c7fa34e084b' || voucherData.voucherType?.id === '650d3389c11f3c7fa34e084b')) ? (
            <>
              <Stack sx={{ maxWidth: '200px' }}>
                <label className=" basis-0 float-left">Allocation Type</label>
                <Select
                  name="allocationType"
                  styles={customStyles()}
                  value={(allocationType && allocationOptions) && allocationOptions.filter((allocation) => allocation.value === allocationType)}
                  onChange={(event) => { setAllocationType(event.value) }}
                  options={allocationOptions}
                ></Select>
                <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !voucherData.bank) ? "This field is required" : validError.bank}</Typography>
              </Stack>
              <Grid container spacing={2}>
                <Grid item xs={7}>
                  <div className="mt-20">
                    <Stack className="mt-20" style={{ height: '300px' }}>
                      <Box
                        id="accountListGrid"
                        onDrop={(event) =>
                          drop_handler(event, "container-right", "accountList")
                        }
                        onDragOver={(event) => dragover_handler(event)}
                        style={{ height: '300px' }}
                      >
                        <AgGridTable
                          rowData={rowData}
                          columnDefs={columnDefs}
                          onCellKeyDown={handleCellKeyDown}
                          onGridReady={onGridReady}
                          rowGroupPanelShow="never"
                          gridRef={gridRef}
                          statusBar={statusBar}
                          columnTypes={columnTypes}
                          onSelectionChanged={onSelectionChanged}
                          onCellValueChanged={onCellValueChanged}
                          getContextMenuItems={getContextMenuItems}
                          floatingFilter={false}
                        />
                      </Box>
                      <Box className="m-5" sx={{ pb: 1, border: "1px dashed grey" }}>
                        <Grid container spacing={2} className="justify-center mt-1">
                          <Grid item xs={2}>
                            <label className="basis-0 float-left">
                              Total Debit :
                            </label>
                            <TextField
                              className="w-[100%]"
                              name="totalDebits"
                              value={totalDebits === 0 ? Number(0).toFixed(2) : Number(totalDebits).toFixed(2)}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <label className="basis-0 float-left">
                              Total Credit :
                            </label>
                            <TextField
                              className="w-[100%]"
                              name="totalCredits"
                              value={totalCredits === 0 ? Number(0).toFixed(2) : Number(totalCredits).toFixed(2)}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <label className=" basis-0 float-left">
                              Difference :
                            </label>
                            <TextField
                              className="w-[100%]"
                              name="eurorate"
                              size="small"
                              value={(totalDebits - totalCredits) === 0 ? Number(0).toFixed(2) : Number(totalDebits - totalCredits).toFixed(2)}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2} className="mt-20">
                            <TextField
                              className="w-[100%]"
                              name="AED"
                              value={voucherData.currency}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2} className="mt-20">
                            <TextField
                              className="w-[100%]"
                              name="rate"
                              value={voucherData.euroRate === 0 ? Number(0).toFixed(4) : Number(voucherData.euroRate).toFixed(4)}
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} className="justify-center mt-5">
                          <Grid item xs={2}>
                            <TextField
                              className="w-[100%]"
                              name="convertedDebits"
                              size="small"
                              value={
                                voucherData.euroRate === 0
                                  ? Number(0).toFixed(2)
                                  : Number(
                                    totalDebits / voucherData.euroRate
                                  ).toFixed(2)
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <TextField
                              className="w-[100%]"
                              name="convertedCredits"
                              size="small"
                              value={
                                voucherData.euroRate === 0
                                  ? Number(0).toFixed(2)
                                  : Number(
                                    totalCredits / voucherData.euroRate
                                  ).toFixed(2)
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <TextField
                              className="w-[100%]"
                              name="diff"
                              size="small"
                              value={
                                voucherData.euroRate === 0
                                  ? Number(0).toFixed(2)
                                  : (Number(
                                    totalDebits / voucherData.euroRate
                                  ).toFixed(2) -
                                    Number(
                                      totalCredits / voucherData.euroRate
                                    ).toFixed(2)) === 0 ? Number(0).toFixed(2) : Number(Number(
                                      totalDebits / voucherData.euroRate
                                    ).toFixed(2) -
                                      Number(
                                        totalCredits / voucherData.euroRate
                                      ).toFixed(2)).toFixed(2)
                              }
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <TextField
                              className="w-[100%]"
                              name="EUR"
                              value="EUR"
                              size="small"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={2}></Grid>
                        </Grid>
                      </Box>
                    </Stack>

                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div className="p-2" style={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
                    <Stack className="mt-20" style={{ height: "300px" }}>
                      <Box
                        style={{ height: '300px' }}
                      >
                        {console.log(":: allocation row data", allocationRowDataCashReceipt)}
                        <AgGridTable
                          rowData={allocationRowDataCashReceipt}
                          columnDefs={allocationColumnDefsCashReceipt}
                          rowGroupPanelShow="never"
                          hideCheckbox={true}
                          floatingFilter={false}
                        />
                      </Box>
                      <Box
                        className="p-8 m-8 "
                        sx={{ pb: 1, border: "1px dashed grey" }}
                      >
                        <Grid
                          container
                          spacing={2}
                          className="justify-center mt-1"
                        >
                          <Grid item xs={4}>
                            <Stack>
                              <label className="basis-0 float-left">
                                Amount To Be Allocated
                              </label>
                              <TextField
                                className="w-[100%]"
                                name="amount"
                                value={totalCredits === 0 ? Number(0).toFixed(2) : Number(totalCredits).toFixed(2)}
                                size="small"
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </Stack>
                          </Grid>

                          <Grid item xs={4}>
                            <Stack>
                              <label className="basis-0 float-left">
                                Allocated
                              </label>
                              <TextField
                                className="w-[100%]"
                                name="allocated"
                                value={totalAllocated}
                                size="small"
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </Stack>
                          </Grid>

                          <Grid item xs={4}>
                            <Stack>
                              <label className="basis-0 float-left">Balace</label>
                              <TextField
                                className="w-[100%]"
                                name="balance"
                                value={totalCredits - 0}
                                size="small"
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </Stack>
                          </Grid>
                        </Grid>
                      </Box>
                    </Stack>
                  </div>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <div className="mt-20">
                <Stack className="mt-20" style={{ height: "300px" }}>
                  <Box
                    id="accountListGrid"
                    onDrop={(event) =>
                      drop_handler(event, "container-right", "accountList")
                    }
                    onDragOver={(event) => dragover_handler(event)}
                    style={{ height: '300px' }}
                  >
                    <AgGridTable
                      rowData={rowData}
                      columnDefs={columnDefs}
                      onCellKeyDown={handleCellKeyDown}
                      onGridReady={onGridReady}
                      rowGroupPanelShow="never"
                      gridRef={gridRef}
                      statusBar={statusBar}
                      columnTypes={columnTypes}
                      onSelectionChanged={onSelectionChanged}
                      onCellValueChanged={onCellValueChanged}
                      getContextMenuItems={getContextMenuItems}
                      floatingFilter={false}
                    />
                  </Box>
                </Stack>
                <Box className="m-5" sx={{ pb: 1, border: "1px dashed grey" }}>
                  <Grid container spacing={2} className="justify-center mt-1">
                    <Grid item xs={2}>
                      <label className="basis-0 float-left">
                        Total Debit :
                      </label>
                      <TextField
                        className="w-[100%]"
                        name="totalDebits"
                        value={totalDebits === 0 ? Number(0).toFixed(2) : Number(totalDebits).toFixed(2)}
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <label className="basis-0 float-left">
                        Total Credit :
                      </label>
                      <TextField
                        className="w-[100%]"
                        name="totalCredits"
                        value={totalCredits === 0 ? Number(0).toFixed(2) : Number(totalCredits).toFixed(2)}
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <label className=" basis-0 float-left">
                        Difference :
                      </label>
                      <TextField
                        className="w-[100%]"
                        name="eurorate"
                        size="small"
                        value={(Math.abs(totalDebits - totalCredits).toFixed(2) === (Number(0).toFixed(2))) ? (Number(0).toFixed(2)) : Number(totalDebits - totalCredits).toFixed(2)}
                        // value={(totalDebits - totalCredits)  === 0 ? Number(0).toFixed(2) : Number(totalDebits - totalCredits).toFixed(2)}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2} className="mt-20">
                      <TextField
                        className="w-[100%]"
                        name="AED"
                        value={voucherData.currency}
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2} className="mt-20">
                      <TextField
                        className="w-[100%]"
                        name="rate"
                        value={voucherData.euroRate === 0 ? Number(0).toFixed(4) : Number(voucherData.euroRate).toFixed(4)}
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className="justify-center mt-5">
                    <Grid item xs={2}>
                      <TextField
                        className="w-[100%]"
                        name="convertedDebits"
                        size="small"
                        value={
                          voucherData.euroRate === 0
                            ? Number(0).toFixed(2)
                            : Number(
                              totalDebits / voucherData.euroRate
                            ).toFixed(2)
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        className="w-[100%]"
                        name="convertedCredits"
                        size="small"
                        value={
                          voucherData.euroRate === 0
                            ? Number(0).toFixed(2)
                            : Number(
                              totalCredits / voucherData.euroRate
                            ).toFixed(2)
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        className="w-[100%]"
                        name="diff"
                        size="small"
                        value={
                          voucherData.euroRate === 0
                            ? Number(0).toFixed(2)
                            : (Number(
                              totalDebits / voucherData.euroRate
                            ).toFixed(2) -
                              Number(
                                totalCredits / voucherData.euroRate
                              ).toFixed(2)) === 0 ? Number(0).toFixed(2) : Number(Number(
                                totalDebits / voucherData.euroRate
                              ).toFixed(2) -
                                Number(
                                  totalCredits / voucherData.euroRate
                                ).toFixed(2)).toFixed(2)
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        className="w-[100%]"
                        name="EUR"
                        value="EUR"
                        size="small"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={2}></Grid>
                  </Grid>
                </Box>
              </div>
            </>
          )}

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleEuroRateClose}
        open={euroRateOpen}
      >
        <DialogTitle>{"Euro rate"}</DialogTitle>
        <Divider />
        <DialogContent>
          <Alert severity="error" className="mb-16">
            {" "}
            <AlertTitle>Error</AlertTitle>Euro Rate is not available for
            date {moment(voucherData?.docDate).format('DD-MM-YYYY')}
          </Alert>
          <Grid container>
            <Grid item xs={6}>
              <label>Euro Rate: </label>
            </Grid>
            <Grid item xs={6}>
              <TextField
                className="w-[100%]"
                name="eurorate"
                error={validError.euroRate ? true : false}
                onChange={(params) => {
                  setFutureEuroRate(params.target.value);
                  setValidError({
                    ...validError,
                    euroRate: checkNumber(params.target.value),
                  });
                }}
                value={futureEuroRate}
                helperText={validError.euroRate}
                disabled={params.viewid ? true : false}
              // style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            disabled={futureEuroRate ? false : true}
            onClick={handleEuroRateSave}
          >
            <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={handleEuroRateClose}
          >
            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={attachmentOpen}
        onClose={handleAttachmentClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Do you want to keep original attachment ?`}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleAttachmentSubmit}>Yes</Button>
          <Button onClick={handleAttachmentClose}>No</Button>
        </DialogActions>
      </Dialog>
    </Main >

        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={handleClose}
          open={open}
        >
          <DialogTitle>
            <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
              <span>{modalName}</span>
              <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                <Button onClick={handleClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <ViewVoucher fileName={voucherData?.invoiceDocument} />
          </DialogContent>
        </Dialog>

        <Drawer
          anchor={"right"}
          PaperProps={{
            sx: {
              width: "20%",
            },
          }}
          variant="persistent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
            },
          }}
          open={drawer}
        >
          <div className="flex">
            <Typography className="p-10 text-xl text-[#ffa726]">
              SubLedger List
            </Typography>
            <IconButton
              className="ml-auto p-10"
              size="small"
              onClick={handleDrawerClose}
              sx={{ alignSelf: "end" }}
            >
              <FuseSvgIcon>material-outline:close</FuseSvgIcon>
            </IconButton>
          </div>
          <Divider />
          <TextField
            className="mt-20 my-10 mx-10"
            name="searchbarvalue"
            // value={(searchsubLedgr.length > 0) && voucherStatusOptions.filter((list) => voucherStatus.includes(list.value))}
            onChange={handleSearchBarChange}
            placeholder="Search"
          />
          <Box id="accountList" onDragOver={(event) => dragover_handler(event)}>
            {subLedgrOptions.length > 0 &&
              subLedgrOptions.map((ledger) => {
                return (
                  <MenuItem
                    className="pl-20 pb-10 pt-10 pr-10"
                    draggable={true}
                    id={ledger.fullname}
                    onDragStart={(event) =>
                      dragstart_handler(event, ledger.fullname)
                    }
                  >
                    {ledger.fullname}
                  </MenuItem>
                );
              })}
          </Box>
        </Drawer>
      </Box >
    </>
  );
};

export default EditVoucher;
